/**
 * Calcul PUR du déplacement d'une carte entre deux colonnes d'un `DropBoard`.
 *
 * Vit dans son propre fichier (et pas dans DragDropBoard.jsx) parce qu'un
 * export non-composant depuis un `.jsx` casse le Fast Refresh de Vite — règle
 * eslint `react-refresh/only-export-components`, déjà payée une fois par un
 * écran blanc sur ce projet.
 *
 * @param {object}   p
 * @param {Array}    p.items    la collection à corriger (ex. les hits ES).
 * @param {string}   p.itemKey  champ qui identifie une carte (ex. `nid`).
 * @param {object}   p.patch    { champ de l'item: clé de la colonne cible }.
 * @param {*}        p.itemId   identifiant de la carte déposée.
 * @param {object}   p.column   données déclarées par la colonne cible.
 *
 * @returns {null|{index: number, writes: Array<[string, *]>, previous: Array<[string, *]>}}
 *   `null` quand il n'y a rien à faire : carte inconnue, colonne absente, ou
 *   carte déjà dans la colonne visée (un dépôt sur place ne doit ni réécrire ni
 *   POSTer). Sinon l'index de l'item, les écritures à appliquer, et les valeurs
 *   d'avant — de quoi revenir en arrière si le serveur refuse.
 */
export function planBoardMove({ items, itemKey, patch, itemId, column }) {
  if (!Array.isArray(items) || !column || itemId === null || itemId === undefined) return null;
  const entries = Object.entries(patch || {});
  if (entries.length === 0) return null;
  const index = items.findIndex((it) => it && String(it[itemKey]) === String(itemId));
  if (index < 0) return null;
  const item = items[index];
  const unchanged = entries.every(([field, key]) => String(item[field] ?? '') === String(column[key] ?? ''));
  if (unchanged) return null;
  return {
    index,
    writes: entries.map(([field, key]) => [field, column[key]]),
    previous: entries.map(([field]) => [field, item[field]]),
  };
}
